export default {
	POST: () => "/consent",
};
